<template>
  <div class="page-container">
    <!-- 筛选区域 -->
    <Filter :params="params" @search="searchData"></Filter>

    <!-- 表格区域 -->
    <Table
      ref="tableRef"
      :tableData="tableDataList"
      :total="data.total"
      @update="updatePage"
      @sort-change="handleSortChange"
    >
      <!-- 下发时间 -->
      <el-table-column
        prop="deployTime"
        :label="$t('smartRouting.deliveryRecords.dispatchTime')"
        sortable="custom"
        width="160"
      />
      <el-table-column
        prop="deployCode"
        :label="$t('smartRouting.deliveryRecords.deployCode')"
        sortable="custom"
        width="160"
      />
      <!-- 下发对象 -->
      <el-table-column
        prop="resourceType"
        :label="$t('smartRouting.deliveryRecords.dispatchTarget')"
        width="140"
      >
        <template #default="{ row }">
          <el-tag :type="targetTypeTagMap[row.resourceType] || '--'">
            {{ targetTypeMap[row.resourceType] || '--' }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- 名称/编码 -->
      <el-table-column
        prop="nameCode"
        :label="$t('smartRouting.deliveryRecords.nameCode')"
        width="180"
      >
        <template #default="{ row }">
          <div>{{ row.resourceName }}</div>
          <div class="sub-text">{{ row.resourceCode }}</div>
        </template>
      </el-table-column>

      <!-- 目标设备 -->
      <el-table-column
        prop="targetDevice"
        :label="$t('smartRouting.deliveryRecords.targetDevice')"
      >
        <template #default="{ row }">
          <el-tag
            v-for="(device, index) in row.targetDevice"
            :key="index"
            size="small"
            style="margin: 4px"
          >
            {{ device.robotName }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- 策略 -->
      <!-- <el-table-column
        prop="strategy"
        :label="$t('smartRouting.deliveryRecords.strategy')"
        width="100"
      >
        <template #default="{ row }">
          {{ strategyMap[row.strategy] || row.strategy }}
        </template>
      </el-table-column> -->

      <!-- 结果 -->
      <el-table-column
        prop="result"
        :label="$t('smartRouting.deliveryRecords.result')"
        width="120"
      >
        <template #default="{ row }">
          <el-tag :type="resultTagMap[row.result] || ''">
            {{ resultMap[row.result] || row.result }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- 操作人 -->
      <el-table-column
        prop="operator"
        :label="$t('smartRouting.deliveryRecords.operator')"
        width="100"
      />

      <!-- 操作 -->
      <el-table-column
        :label="$t('smartRouting.deliveryRecords.operation')"
        fixed="right"
        width="100"
      >
        <template #default="{ row }">
          <el-tooltip :content="$t('smartRouting.deliveryRecords.viewDetail')" placement="top">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-view"
              @click="viewDetail(row)"
            >
              <!-- {{ $t('smartRouting.deliveryRecords.viewDetail') }} -->
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </Table>

    <!-- 查看详情弹窗 -->
    <el-dialog
      :title="$t('smartRouting.deliveryRecords.detail')"
      v-model="data.dialogDetailVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
      width="1200px"
    >
      <!-- ===== 头部基础信息区 ===== -->
      <div class="detail-header">
        <div class="header-row-1">
          <span class="task-id">{{ detailData.deployCode }}</span>
          <el-tag
            size="small"
            :type="targetTypeTagMap[detailData.resourceType] || '--'"
          >
            {{ targetTypeMap[detailData.resourceType] || '--' }}
          </el-tag>
          <el-tag
            :type="resultTagMap[detailData.result]"
            size="small"
            effect="light"
            class="status-tag"
          >
            {{ resultMap[detailData.result] }}
          </el-tag>
        </div>
        <div class="header-row-2">
          {{ detailData.resourceName }}
          {{
            detailData.resourceCode ? ' ' + detailData.resourceCode : ' P-009'
          }}
          · {{ $t('smartRouting.deliveryRecords.strategy') }}
          {{ strategyMap[detailData.strategy] }} ·
          {{ $t('smartRouting.deliveryRecords.operator') }}
          {{ detailData.operator }} · {{ detailData.deployTime }}
        </div>
      </div>

      <el-divider class="custom-divider" />

      <!-- ===== 下发明细表格 ===== -->
      <div class="detail-table-section">
        <div class="section-title">
          {{ $t('smartRouting.deliveryRecords.sectionTitle') }}
        </div>
        <el-table
          :data="detailTableData"
          stripe
          max-height="420"
          style="width: 100%"
          :header-cell-style="{
            background: '#f5f6f7',
            color: '#646a73',
            fontWeight: 500
          }"
        >
          <el-table-column
            prop="deviceCode"
            :label="$t('smartRouting.deliveryRecords.deviceCode')"
          />
          <el-table-column
            prop="resourceTypeName"
            :label="$t('smartRouting.deliveryRecords.resourceTypeName')"
          />
          <el-table-column
            prop="resourceName"
            :label="$t('smartRouting.deliveryRecords.resourceName')"
          />
          <el-table-column
            prop="resourceCode"
            :label="$t('smartRouting.deliveryRecords.resourceCode')"
          />
          <el-table-column
            prop="status"
            :label="$t('smartRouting.deliveryRecords.status')"
          >
            <template #default="{ row }">
              <el-tag
                :type="statusTagMap[row.status]"
                size="small"
                effect="light"
              >
                {{ statusMap[row.status] || '--' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="durationSeconds"
            :label="$t('smartRouting.deliveryRecords.durationSeconds')"
            width="100"
          />
          <el-table-column
            prop="failReason"
            :label="$t('smartRouting.deliveryRecords.failReason')"
          />
        </el-table>
      </div>

      <template #footer>
        <el-button size="mini" @click="data.dialogDetailVisible = false">
          {{ $t('smartRouting.deliveryRecords.confirm') }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/utils/request'
import { ElMessage } from 'element-plus'
import Table from '@/components/table/index'
import Filter from '@/components/table/filter'
import { ref, reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { arrayToMap } from '@/utils/index'

import { reqDeployPage, reqDeployDetail } from '@/api/map'

export default {
  name: 'DispatchRecord',
  components: {
    Table,
    Filter
  },
  setup () {
    const store = useStore()
    const { t } = useI18n()

    const state = reactive({
      tableRef: null,
      curLang: computed(() => store.state.lang),
      authList: JSON.parse(window.localStorage.getItem('authList') || '[]'),
      sortData: {},
      detailTableData: []
    })

    const resultList = [
      { label: t('smartRouting.deliveryRecords.resultList[0]'), value: 1 },
      { label: t('smartRouting.deliveryRecords.resultList[1]'), value: 2 },
      { label: t('smartRouting.deliveryRecords.resultList[2]'), value: 3 },
      { label: t('smartRouting.deliveryRecords.resultList[3]'), value: 4 },
      { label: t('smartRouting.deliveryRecords.resultList[4]'), value: 5 }
    ]

    const resultMap = arrayToMap(resultList, 'value', 'label')

    const resultTagMap = {
      1: 'info',
      2: '',
      3: 'success',
      4: 'warning',
      5: 'danger'
    }

    const targetList = [
      {
        label: t('smartRouting.deliveryRecords.targetList[0]'),
        value: 'ACTION'
      },
      {
        label: t('smartRouting.deliveryRecords.targetList[1]'),
        value: 'DANCE'
      },
      { label: t('smartRouting.deliveryRecords.targetList[2]'), value: 'ROUTE' },
      { label: t('smartRouting.deliveryRecords.targetList[3]'), value: 'SKILL' }
    ]

    const targetTypeMap = arrayToMap(targetList, 'value', 'label')

    const targetTypeTagMap = {
      ACTION: 'warning',
      ROUTE: '',
      DANCE: 'success'
    }

    // 策略 - strategyMap
    const strategyMap = {
      FULL:  t('smartRouting.deliveryRecords.strategyList[0]'),
      GRAY:  t('smartRouting.deliveryRecords.strategyList[1]'),
      INCR:  t('smartRouting.deliveryRecords.strategyList[2]')
    }

    const statusList = [
      { label: t('smartRouting.deliveryRecords.statusList[0]'), value: 0 },
      { label: t('smartRouting.deliveryRecords.statusList[1]'), value: 1 },
      { label: t('smartRouting.deliveryRecords.statusList[2]'), value: 2 },
      { label: t('smartRouting.deliveryRecords.statusList[3]'), value: 3 },
      { label: t('smartRouting.deliveryRecords.statusList[4]'), value: 4 },
      { label: t('smartRouting.deliveryRecords.statusList[5]'), value: 5 },
      { label: t('smartRouting.deliveryRecords.statusList[6]'), value: 6 },
      { label: t('smartRouting.deliveryRecords.statusList[7]'), value: 7 }
    ]

    const statusMap = arrayToMap(statusList, 'value', 'label')

    const statusTagMap = {
      0: 'info',
      1: '',
      2: '',
      3: 'success',
      4: 'warning',
      5: '',
      6: 'success',
      7: 'danger'
    }

    // ===== 筛选参数配置 =====
    const params = [
      {
        type: 'Date',
        key: 'dateRange',
        value: [],
        label: t('smartRouting.deliveryRecords.dispatchTime'),
        options: {
          type: 'datetimerange',
          format: 'YYYY-MM-DD HH:mm:ss',
          'value-format': 'YYYY-MM-DD HH:mm:ss',
          'range-separator': t('activity.detail.to'),
          'start-placeholder': t('activity.list.startDate'),
          'end-placeholder': t('activity.list.endDate'),
          'default-time': [
            new Date(2000, 1, 1, 0, 0, 0),
            new Date(2000, 1, 1, 23, 59, 59)
          ]
        }
      },
      {
        key: 'nameKeyword',
        value: '',
        label: t('smartRouting.deliveryRecords.nameCode'),
        placeholder: t('smartRouting.deliveryRecords.searchNameCode')
      },
      {
        key: 'resourceType',
        type: 'Select',
        value: '',
        label: t('smartRouting.deliveryRecords.dispatchTarget'),
        options: {
          data: targetList
        }
      },
      {
        key: 'deviceKeyword',
        value: '',
        label: t('smartRouting.deliveryRecords.targetDevice'),
        placeholder: t('smartRouting.deliveryRecords.searchTargetDevice')
      },
      {
        key: 'result',
        type: 'Select',
        value: '',
        label: t('smartRouting.deliveryRecords.result'),
        options: {
          data: resultList
        }
      }
    ]

    // ===== 数据状态 =====
    const data = reactive({
      page: 1,
      size: 10,
      total: 0,
      dialogDetailVisible: false,
      dialogRetryVisible: false
    })

    const tableDataList = ref([])
    const detailData = ref({})
    const query = reactive({})

    // ===== API 请求 =====
    const getData = async () => {
      try {
        const res = await reqDeployPage(
          Object.assign(query, {
            ...query,
            ...state.sortData,
            page: data.page,
            size: data.size
          })
        )
        tableDataList.value = res.records || []
        data.total = res.total || 0
      } catch (error) {
        console.error('获取下发记录失败:', error)
        ElMessage.error(
          t('smartRouting.deliveryRecords.message?.getDataFailed') ||
            '获取数据失败'
        )
      }
    }

    // ===== 搜索 =====
    const searchData = searchParams => {
      Object.assign(query, searchParams)
      data.page = 1
      getData()
    }

    // ===== 分页 =====
    const updatePage = (page, size) => {
      data.page = page || 1
      data.size = size || 10
      getData()
    }

    // ===== 排序 =====
    const handleSortChange = ({ prop, order }) => {
      const orderMap = { ascending: 'asc', descending: 'desc' }
      state.sortData = {
        sortField: prop,
        sort: orderMap[order] || ''
      }
      getData()
    }

    // ===== 查看详情 =====
    const viewDetail = row => {
      detailData.value = { ...row }
      data.dialogDetailVisible = true
      getDeployDetail(row.id)
    }
    const getDeployDetail = async id => {
      try {
        const res = await reqDeployDetail(id)
        state.detailTableData = res.details || []
      } catch (error) {
        console.error('获取下发记录失败:', error)
        ElMessage.error(
          t('smartRouting.deliveryRecords.message?.getDataFailed') ||
            '获取数据失败'
        )
      }
    }

    // ===== 初始化加载 =====
    getData()

    return {
      ...toRefs(state),
      params,
      data,
      tableDataList,
      detailData,
      targetTypeMap,
      targetTypeTagMap,
      strategyMap,
      resultMap,
      resultTagMap,
      statusMap,
      statusTagMap,
      searchData,
      updatePage,
      handleSortChange,
      viewDetail
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.sub-text {
  font-size: 12px;
  color: #909399;
}

/* ===== 详情弹窗样式 ===== */
.detail-header {
  padding: 0 4px;

  .header-row-1 {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;

    .task-id {
      font-weight: 600;
      font-size: 14px;
      color: #1f2329;
    }

    .tag-type {
      font-size: 13px;
      color: #646a73;
    }

    .text-muted {
      color: #8f959e;
      font-size: 13px;
    }
  }

  .header-row-2 {
    color: #646a73;
    font-size: 13px;
    line-height: 22px;
  }
}

.custom-divider {
  margin: 16px 0 20px 0;
}

.detail-table-section {
  .section-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #1f2329;
  }
}
</style>
